// @flow

export const CONTAINED_VIEW = 'contained'
export const OUTLINED_VIEW = 'outlined'
export const DESATURATED_VIEW = 'desaturated'
